<template>
    <v-card>
              <v-card-title>
                <span class="headline">REGISTRAR PAGO CREDITO {{getInfoCredito.serie}} - {{getInfoCredito.numero}}</span>
                <span  class="font-weight-thin">A nombre de: {{getInfoCredito.cliente}}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="editedItem.descripcion" label="Descripción" placeholder="Ejemplo: Primer Abono" required></v-text-field>
                    </v-col>
                    <v-col cols="12">

                      <!-- Inicio de modal para fecha de factura -->
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedDateFormatted"
              label="Fecha Abono"
              persistent-hint
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="editedItem.fecha"
            locale="es-ES"
            no-title
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>

      <!-- FIN  de modal para fecha de factura -->
                    </v-col>
                    <v-col cols="6">
                      <v-text-field v-model="editedItem.monto" :rules="[editedItem.monto>-1 ||'El monto deber ser mayor a Q 1 ' ]" prefix="Q " label="Monto"  required></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field prefix="Q "  :rules="[() => calcularSaldo>-1 || 'El saldo no puede ser un NEGATIVO']" label="Saldo" :value="calcularSaldo" readonly></v-text-field>
                     
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" dark @click="guardar" >Registrar</v-btn>
              </v-card-actions>
            </v-card>
</template>
<script>
import dayjs from "dayjs";
import axios from "axios";
import Swal from 'sweetalert2'
import {mapGetters} from 'vuex'

export default {
    name:"CrearEditarAbonos",
    data() {
        return {
            property: 'value',
            menu2:false,
            editedItem:{
                descripcion:'',
                fecha:dayjs().format("YYYY-MM-DD"),
                monto:1,
                saldo:0
            }
        };
    },
    computed:{
      ...mapGetters(['getInfoCredito','getTotalAbonado','getTokenUser','getUrlApi']),
      computedDateFormatted () {
        return dayjs(this.editedItem.fecha).format("DD/MM/YYYY")
        },

        calcularSaldo(){
          return this.getInfoCredito.totalcredito - (this.getTotalAbonado+parseFloat(this.editedItem.monto))
        }

        
    },
    methods: {
      establecerNuevoSaldo(){
        this.editedItem.saldo = this.calcularSaldo
        this.editedItem.iddocumento = this.getInfoCredito.idcredito
      },
      async guardar(){
        this.establecerNuevoSaldo()
        try {
          await axios.post(`${this.getUrlApi}/abonos/`,this.editedItem,this.getTokenUser)
          //await  this.$store.dispatch('setAbonos',this.getIdCredito)
          await  this.$store.dispatch('setAbonos',this.getInfoCredito.idcredito)

          Swal.fire({
            icon: 'success',
            title: 'El abono fue registrado',
            showConfirmButton: false,
            timer: 1500
          })

        } catch (error) {
          console.log(error)
           Swal.fire('No se puedo registrar Abono','Ocurrio un error al intentar registrar el abono','error')
        }
      },
    },
}
</script>